// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.candidature-content p {
  margin: 1.5rem 0;
}

.analyze-info {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #fff7ed;
  border-color: "#FED7AA";
}

/* Style pour les offres expirées */
.expired-offer {
  opacity: 0.6;
  color: #6b7280;
  position: relative;
}

.expired-offer::before {
  content: "EXPIRÉ";
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #f3f4f6;
  color: #6b7280;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: bold;
  z-index: 1;
}
.disabled-analyse-button {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Analyse/Analyse.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".candidature-content p {\n  margin: 1.5rem 0;\n}\n\n.analyze-info {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-color: #fff7ed;\n  border-color: \"#FED7AA\";\n}\n\n/* Style pour les offres expirées */\n.expired-offer {\n  opacity: 0.6;\n  color: #6b7280;\n  position: relative;\n}\n\n.expired-offer::before {\n  content: \"EXPIRÉ\";\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #f3f4f6;\n  color: #6b7280;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: bold;\n  z-index: 1;\n}\n.disabled-analyse-button {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
